<template>
  <div>
    <div id="map-div" :class="cclass" :style="wStyle">
      <div id="map_canvas" class="center-block full" :style="mcStyle" :class="mcClass"> </div>
    </div>
    <audio ref="alarm" muted>
      <source src="static/audio/alarm.mp3" type="audio/mp3">
      <source src="static/audio/alarm.wav" type="audio/wav"> Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
// map_canvas must have height and width defined
// mcClass default: 100% everything half : 50% all
import * as R from 'ramda'
import logopemex from '../assets/imgs/logos/logo_pemex_original.png'
import MarkerClusterer from 'marker-clusterer-plus'
import Leak from '../models/leak'
import { MAX_LEAKS_PROCESSED_IN_BATCH } from '../common/constants.js'
export default {
  props: ['cclass', 'mcStyle', 'wStyle', 'mcClass'],
  data() {
    return {
      statusAlarm: 'place_red',
      // map: undefined,
      mapReady: false,
      markers: [],
      infowindow: undefined,
      leakIndex: 0,
      markerClusterer: undefined,
      is_chrome: navigator.userAgent.indexOf('Chrome') > -1,
      is_explorer: navigator.userAgent.indexOf('MSIE') > -1,
      is_firefox: navigator.userAgent.indexOf('Firefox') > -1,
      is_safari: navigator.userAgent.indexOf('Safari') > -1,
      is_opera: navigator.userAgent.toLowerCase().indexOf('op') > -1
    }
  },
  methods: {
    imgUrl(url) {
      return require(`imgs/icons/${url}`)
    },
    alarmStatus() {
      const skipAlarm = process.env.NODE_ENV === 'development';

      if (skipAlarm) {
        return;
      }

      let audio = this.$refs.alarm;

      if (!audio) {
        return;
      }
      const leakFound = this.$store.getters.GET_HOME_LEAKS_TABLE.some(l => { 
        if(l.is_operational_movement === true) {
          return false;
        }
        return l.status == Leak.Status.SYSTEM_IDENTIFIED;
      });

      if (leakFound) {
        audio.muted = false;
        if (audio.paused) {
          audio.play();
        }
      } else {
        audio.pause();
        audio.muted = true;
      }
    },
    drawDucts() {
      const data = this.$store.getters.GET_ROUTES
      var colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];
      let index = 0

      const sections = this.$store.getters.allowedSections
      for (let id in data) {
        if (!R.contains(id, sections)) {
          continue;
        }
        const route = data[id]
        var linePath = new google.maps.Polyline({
          path: route,
          geodesic: false,
          strokeColor: colorArray[index],
          strokeWeight: 5,
          strokeOpacity: 1.0
        })
        linePath.setMap(this.$store.state.map)

        index++
      }
    },
    fillMap() {
      if (!this.$store.state.user) {
        return
      }

      let ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE
      let focusSections = [];
      if (this.$store.state.user.config && this.$store.state.user.config.focus) {
        focusSections = this.$store.state.user.config.focus;
      }
      let focusMarker = []
      Object.keys(ducts).forEach(idSection => {
        let section = ducts[idSection]
        let isFocusRequired = focusSections.length === 0 || focusSections.includes(section.id)
        // var pathData = []
        Object.keys(section.sites).forEach(idSite => {
          let site = section.sites[idSite]
          let imgSrc = 'place_red.gif'
          // 25.510737, -108.236308  ------ punto medio ----- VS PALOS BLANCOS / VS GUAMUCHIL
          if (!site.hasFailure()) {
            imgSrc = 'place_green.png'
          }
          if (site.battery < 12 || site.hasPressueAlarm()) {
            imgSrc = 'place_yellow.png'
          }

          if (site.isOffline() || site.cabinet_door === 1 || site.gps === 0 || site.site_door === 1 || site.pressure === 0) {
            imgSrc = 'place_red.gif'
          }

          let img = new google.maps.MarkerImage(
            this.imgUrl(imgSrc),
          )
          // if (site.lat && site.lon) {
          //   pathData.push(
          //     new google.maps.LatLng(site.lat, site.lon)
          //   )
          // }

          let marker = this.getMarker(section.id, site.id)

          if (!marker) {
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(
                site.lat,
                site.lon
              ),
              map: this.$store.state.map,
              icon: img,
              customInfo: {
                section: section.id,
                site: site.id
              }
            })
            if (isFocusRequired) {
              focusMarker.push(marker)
            }

            this.markerListener(marker, section, site)
            this.markers.push(marker)
          } else {
            marker.setIcon(img)
          }
        })
        this.alarmStatus();
        // var linePath = new google.maps.Polyline({
        //   path: pathData,
        //   geodesic: true,
        //   strokeColor: '#FF0000',
        //   strokeWeight: 2,
        //   strokeOpacity: 1.0
        // })
        // linePath.setMap(this.$store.state.map)
      })
      if (focusMarker.length > 0) {
        var bounds = new google.maps.LatLngBounds()
        focusMarker.forEach(marker => {
          bounds.extend(marker.getPosition())
        })
        this.$store.state.map.fitBounds(bounds)
      }
    },
    fillLeaks() {
      let leaks = this.$store.getters.GET_HOME_LEAKS_TABLE;
      let leaksLength = Object.keys(leaks).length;
      // console.log('leaksLength : ' + leaksLength);
      // console.log(leaks);

      return new Promise((resolve, reject) => {
        this.drawLeak(leaks, leaksLength).then(() => {
          return resolve()
        }).catch(err => {
          return reject(err)
        })
      })
    },
    drawLeak(leaks, len) {
      return new Promise((resolve, reject) => {
        let currentMax = this.leakIndex
        let keys = Object.keys(leaks)

        if (currentMax >= len) {
          return resolve()
        }
        for (let i = currentMax; i < len && i < (currentMax + MAX_LEAKS_PROCESSED_IN_BATCH); i++) {
          let leak = leaks[keys[i]]
          let anim = google.maps.Animation.BOUNCE
          let imgSrc = 'leak_red.gif'
          if (leak.status === Leak.Status.RECOGNIZED) {
            imgSrc = 'leak_blue.png'
            anim = null
          } else if (leak.status === Leak.Status.IN_DAILY_REPORT) {
            imgSrc = 'leak_green.png'
            anim = null
          }
          let updateIcon = false

          var leakMarker = this.getLeakMarker(leak.id)
          var markerTitle = 'Alarma de ' + (leak.type === 1 ? 'Apertura' : 'Cierre');
          if (!leakMarker) {
            leakMarker = new google.maps.Marker({
              position: { lat: leak.lat, lng: leak.lon },
              title: markerTitle,
              // map: this.$store.state.map,
              zIndex: google.maps.Marker.MAX_ZINDEX + 1,
              customInfo: leak
            })
            updateIcon = true
            anim = google.maps.Animation.DROP
            this.leakMarkerListener(leakMarker)
            this.markerClusterer.addMarker(leakMarker)
          } else if (leak.status !== leakMarker.customInfo.status) {
            updateIcon = true
          }
          if (updateIcon) {
            leakMarker.setIcon(
              new google.maps.MarkerImage(
                this.imgUrl(imgSrc)
              )
            )
            leakMarker.setAnimation(anim)
          }
          this.leakIndex++
        }
        this.alarmStatus();
        setTimeout(() => {
          // this.$nextTick(() => {
          return this.drawLeak(leaks, len).then(() => {
            return resolve()
          })
        }, 50)
      })
    },
    markerListener(marker, section, site, imgIcon = 'place_green.png') {
      let fallaMsg = ''
      marker.addListener('click', () => {
        this.$store.state.map.panTo(marker.getPosition())
        google.maps.event.addListenerOnce(this.$store.state.map, 'idle', () => {
          this.$store.state.map.setOptions({
            center: marker.getPosition(),
            zoom: 18
          })
        })
        site._battery <= 10 ? fallaMsg = 'Batería baja' : (site._cabinet_door === 1) ? fallaMsg = 'Fallo en la puerta' : (site._gps === 0) ? fallaMsg = 'Fallo en el gps' : (site._site_door === 1) ? fallaMsg = 'Fallo en la puerta del site' : fallaMsg = ''
        if (fallaMsg !== '') {
          fallaMsg = `${fallaMsg}</p>`
        }

        this.infowindow.setContent(`
        <div style="width: 310px; color: #222; font-weight:400;">        
          <div><img width="116" height="32" src="${logopemex}"></div>
          
          <div style="color: var(--btn-default); font-size: 16px; font-weight:500; margin-top: 10px; margin-bottom: 10px"><span>${section.name}</span></div>

          <div style='width: 50%; float: left; margin-top: 10px'>
            <div style='width: 15%; float: left; text-align: center;' >
              <i class="fa fa-signal" style='font-size: 16px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 85%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.name}</div>
              <div style='font-size: 10px'>Sitio</div>
            </div> 
          </div>

          <div style='width: 50%; float: left; margin-top: 10px'>
            <div style='width: 11%; float: left; text-align: center;' >
              <i class="fa fa-map-marker" style='font-size: 20px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 89%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.city + ', Km ' + site.km}</div>
              <div style='font-size: 10px'>(${site.lat.toFixed(5) + ' , ' + site.lon.toFixed(5)})</div>
            </div> 
          </div>

          <div style='width: 50%; float: left; margin-top: 10px'>
            <div style='width: 15%; float: left; text-align: center;' >
              <i class="fa fa-battery-full" style='font-size: 14px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 85%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.battery}</div>
              <div style='font-size: 10px'>Carga de batería</div>
            </div> 
          </div>

          <div style='width: 50%; float: left; margin-top: 10px'>
            <div style='width: 15%; float: left; text-align: center;' >
              <i class="fa fa-tint" style='font-size: 18px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 85%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.pressure + ' kg/cm2'}</div>
              <div style='font-size: 10px'>Presión</div>
            </div> 
          </div>

          <div style='width: 50%; float: left; margin-top: 10px'>
            <div style='width: 15%; float: left; text-align: center;' >
              <i class="fa fa-power-off" style='font-size: 18px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 85%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.online === 1 ? 'Encendido' : 'Apagado'}</div>
              <div style='font-size: 10px'>Estado</div>
            </div> 
          </div>

          <div style='width: 50%; float: left; margin-top: 10px; margin-bottom: 20px'>
            <div style='width: 15%; float: left; text-align: center;' >
              <i class="fa fa-clock-o" style='font-size: 18px; color: #166FB8; margin-top: 5px' aria-hidden="true"></i>
            </div>
            <div style='width: 85%; float: left; display: block;'>
              <div style='text-align: left; color: var(--btn-default); font-weight:400;'>${site.insertTimestamp}</div>
              <div style='font-size: 10px'>Último evento</div>
            </div> 
          </div>
          
        </div>`
          /* '<div style="width: 300px">' +
          '<img width="116" height="32" src="' + logopemex + '"> ' +
          '<h5> ' +
            section.name +
            ' </h5> <br>' +
            '<h6 style="color: var(--btn-default)">' +
            site.name +
            ' </h6>' +
            '<p style="font-size:12px;">' + site.lat + ' ' + site.lon + '<br>' + site.city + '<br> KM ' + site.km + ' <br> Carga de batería ' + site.battery + ' <br> Presión ' + site.pressure + ' <br> Online ' + site.online + '</p>' + ' <br> Último evento ' + site.insertTimestamp + '</p>' + 
            '<p class="pull-right" style="color: red; font-weight: 800;">' + fallaMsg + '</p>' + '</div>' */
        )
        this.infowindow.open(this.$store.state.map, marker)
      })
    },
    onLeakTableClicked(leak) {
      const leakMarker = this.getLeakMarker(leak.id)
      if (!leakMarker || !leakMarker.customInfo) {
        return
      }
      google.maps.event.trigger(leakMarker, 'click')
    },
    onSiteTableClicked(sectionId, site) {
      const marker = this.getMarker(sectionId, site.id || site._id)
      if (!marker || !marker.customInfo) {
        return
      }
      google.maps.event.trigger(marker, 'click')
    },
    onLocateLeak(leak) {
      const marker = this.getLeakMarker(leak.id)
      if (!marker) {
        return
      }
      this.$store.state.map.panTo(marker.getPosition())
      google.maps.event.addListenerOnce(this.$store.state.map, 'idle', () => {
        this.$store.state.map.setOptions({
          center: marker.getPosition(),
          zoom: 18
        })
      })
    },
    onIdentifyLeak(leak, callback) {
      this.$store.dispatch('IDENTIFY_FUGA', { id: leak.id, status: Leak.Status.RECOGNIZED })
        .then(data => {
          if (data && data.affectedRows === 1) {
            const marker = this.getLeakMarker(leak.id);
            marker.customInfo.status = Leak.Status.RECOGNIZED
            marker.setIcon(
              new google.maps.MarkerImage(
                this.imgUrl('leak_blue.png')
              )
            )
            if (typeof callback === 'function') {
              callback(leak);
            }
            this.infowindow.close()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onPipeLineSelected(section) {
      const markers = (this.markers.filter(marker => marker.customInfo && marker.customInfo.section === section)).slice(0);

      if (markers.length >= 2) {
        const first = markers[0].getPosition();
        const last = (markers.pop()).getPosition();

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(first.lat(), first.lng()));
        bounds.extend(new google.maps.LatLng(last.lat(), last.lng()));

        this.$store.state.map.setOptions({
          center: bounds.getCenter(),
          zoom: 9.6
        })
      }
    },
    leakMarkerListener(marker) {
      marker.addListener('click', () => {
        this.$store.state.map.panTo(marker.getPosition())
        google.maps.event.addListenerOnce(this.$store.state.map, 'idle', () => {
          this.$store.state.map.setOptions({
            center: marker.getPosition(),
            zoom: 18
          })
        })

        let btwnStr = marker.customInfo.isSameSection() ? (
          '<h5 style="margin-top:0.1em;margin-bottom:0em;">Entreeee:</h5>' +
          `<h6 style="margin-top:0.1em;margin-bottom:0em;">${marker.customInfo.section1Name}</h6>` +
          `<h6 style="margin-top:0.1em;margin-bottom:0em;"><span style="font-style:italic">${marker.customInfo.site1Name}</span> ` +
          `y <span style="font-style:italic">${marker.customInfo.site2Name}</span></h6>`
        ) : (
          '<h5 style="margin-top:0.1em;margin-bottom:0em;">Entre:</h5>' +
          `<h6 style="margin-top:0.1em;margin-bottom:0em;">${marker.customInfo.section1Name} <span style="font-style:italic">${marker.customInfo.site1Name}</span> ` +
          `y ${marker.customInfo.section2Name} <span style="font-style:italic">${marker.customInfo.site2Name}</span></h6>`
        )
        this.infowindow.setContent(
          `<div style='width: 310px'>
          <div style='color: var(--btn-default); font-size: 22px; font-weight:500; text-align: center'>
            ${marker.title}
          </div>
          <div style='color: #555; font-size: 14px; font-weight:410; margin-top:10px; text-align: center''>
            ${marker.customInfo.section1Name} <span style='font-size: 12px; color: #888'>(${marker.customInfo.site1Name} y ${marker.customInfo.site2Name})</span>
          </div>
          <div style='color: #555; font-size: 12.5px; font-weight:410; margin-top:10px'>            
            <i class="fa fa-map-marker" style='font-size: 16px; color: #166FB8;' aria-hidden="true"></i>
            <span style="margin-left:5px;">(${marker.customInfo.lat} , ${marker.customInfo.lon})</span>               
          </div>
          <div style='color: #555; font-size: 12.5px; font-weight:410; margin-top:10px'>            
            <i class="fa fa-road" style='font-size: 16px; color: #166FB8;' aria-hidden="true"></i>
            <span>Km ${marker.customInfo.km}</span>               
          </div>
          <div style='color: #555; font-size: 12.5px; font-weight:410; margin-top:10px'>            
            <i class="fa fa-clock-o" style='font-size: 16px; color: #166FB8;' aria-hidden="true"></i>
            <span style="margin-left:5px;">${marker.customInfo.formattedDetectionTimestamp}</span>               
          </div>
          <p class='pull-right' style='color: red; font-weight: 800;'></p>

        </div>`
          /* `<h5 style="color: var(--btn-default); font-weight:800;">${marker.title}</h5>` +
            btwnStr +
            `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Latitud:</span> ${marker.customInfo.lat}</p>` +
            `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Longitud:</span> ${marker.customInfo.lon}</p>` +
            `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Kilómetro:</span> ${marker.customInfo.km}</p>` +
            `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Fecha:</span> ${marker.customInfo.formattedDetectionTimestamp}</p> <br>` +
            (marker.customInfo.status > Leak.Status.SYSTEM_IDENTIFIED ? '' : buttonCode) +
            '<p class="pull-right" style="color: red; font-weight: 800;">' + '' + '</p>' */
        )
        this.infowindow.open(this.$store.state.map, marker)
        if (marker.customInfo.status > Leak.Status.SYSTEM_IDENTIFIED) {
          return
        }
      })
    },
    startGoogleMaps() {
      var myOptions = {
        zoom: 5.2,
        center: {
          lat: 24.9305093,
          lng: -102.2925067
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DEFAULT,
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        styles: [
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{ color: '#e1edfb' }]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'on' }]
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#fafbfd' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          }

        ]
      }

      this.$store.state.map = new google.maps.Map(
        document.getElementById('map_canvas'),
        myOptions
      )
      google.maps.event.addListenerOnce(this.$store.state.map, 'idle', () => {
        this.mapReady = true

        this.infowindow = new google.maps.InfoWindow({
          size: new google.maps.Size(350, 250),
          maxWidth: 350
        })

        /* this.$store.state.map.addListener('zoom_changed', () => {
          const curZoom = this.$store.state.map.getZoom()
          if(curZoom >= 18 && this.markerClusterer.getMaxZoom() > 1) {
            this.markerClusterer.setMaxZoom(1)
            this.markerClusterer.repaint()
          } else if(curZoom < 18 && this.markerClusterer.getMaxZoom() < 100) {
            this.markerClusterer.setMaxZoom(100)
            this.markerClusterer.repaint()
          }
        }) */
      })
      this.markerClusterer = new MarkerClusterer(this.$store.state.map, [], {
        maxZoom: 100,
        // gridSize: 20,
        averageCenter: true
      })
    },
    isMapReady() {
      return this.mapReady
    },
    getMarker(section, site) {
      return this.markers.find(marker =>
        marker.customInfo &&
        marker.customInfo.section === section &&
        marker.customInfo.site === site)
    },
    getLeakMarker(idLeak) {
      let result
      let markers = this.markerClusterer.getMarkers()
      markers.some(marker => {
        if (
          marker.customInfo &&
          marker.customInfo.id === idLeak
        ) {
          result = marker
          return true
        }
        return false
      })
      return result
    },
  },
  mounted() {
    this.mapReady = false
    this.startGoogleMaps();
    // this.drawDucts()
    this.$store.dispatch('LOAD_PIPELINE_SHAPES')
    this.$store.watch(
      (state) => {
        return state.routes
      },
      () => {
        this.drawDucts()
      }, {
      immediate: true
    })

    var wH = $(window).height();
    $('#map_canvas').css({ height: wH });
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.button-style {
  width: 150px;
  padding: 20px;
  background-color: $amarilloC !important;
}

.half {
  height: 50vh;
  width: 50vw;

  @include tablet {
    width: 100vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// Map.vue?7d22622e